import { render } from "./VehicleRegNumberBadge.vue?vue&type=template&id=30f9541e&scoped=true"
import script from "./VehicleRegNumberBadge.vue?vue&type=script&lang=js"
export * from "./VehicleRegNumberBadge.vue?vue&type=script&lang=js"

import "./VehicleRegNumberBadge.vue?vue&type=style&index=0&id=30f9541e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f9541e"]])

export default __exports__